<template>
    <div class="wb-project-name">
        <input class="wb-project-name-input"
               @click="inputEdit()"
               @keydown.stop
               type="text"
               ref="name"
               :value="value"
               :class="{'wb-project-name-input-active': mode === 'edit'}"
               :readonly="mode === 'readonly'"
               @mouseover="inputHover = true"
               @mouseout="inputHover = false"
               @change="storeConfiguration.setProjectName($refs.name.value)"
        >
<!--        <div class="wb-project-name-changer-anchor">-->
<!--            <div class="wb-project-name-changer"-->
<!--                 :class="{'wb-project-name-changer-edit': mode === 'edit'}"-->
<!--                 v-on:click="changeModeManual()"-->
<!--            >-->
<!--                <SVGEdit v-if="mode === 'readonly'"/>-->
<!--                <SVGConfirm v-else/>-->
<!--            </div>-->
<!--        </div>-->
    </div>
</template>

<script>
import SVGEdit from '@/UI/Components/SVG/SVGEdit.vue';
import SVGConfirm from '@/UI/Components/SVG/SVGConfirm.vue';
import { useConfigurationStore } from '@/Store/storeConfiguration';

export default {
    name: 'NavbarProjectName',
    components: { SVGConfirm, SVGEdit },
    setup() {
        const storeConfiguration = useConfigurationStore();

        return {
            storeConfiguration,
        };
    },
    data() {
        return {
            value: 'Test',
            mode: 'readonly',
            inputHover: false,
        };
    },
    methods: {
        changeModeManual() {
            if (this.mode === 'edit') {
                this.inputHover = false;
                this.value = this.$refs.name.value;
                this.mode = 'readonly';
                useConfigurationStore().setProjectName(this.$refs.name.value);
            } else {
                this.mode = 'edit';
            }
        },
        inputEdit() {
            this.mode = 'edit';
        },
    },
    computed: {
        name() {
          return useConfigurationStore().projectName;
        },
    },
    watch: {
      name(newValue) {
        this.value = newValue;
      },
    },
    mounted() {
        this.value = useConfigurationStore().projectName;
    },
};
</script>

<style scoped lang="scss">
@import "CSS/common.scss";
@import "CSS/colors.scss";
@import "CSS/fonts.scss";
@import "CSS/animations.scss";

.wb-project-name {
    display: flex;
    flex-direction: row;
    height: 40px;
    padding: 0 32px;
}

.wb-project-name-input {
    padding: 0 40px 0 16px;
    vertical-align: center;
    height: 100%;
    box-sizing: border-box;
    outline: none;
    border: none;
    color: $darkBlue;
    //background-color: $gray1;
    background-color: $white;
    border-radius: 4px;
    @include font-h1;
    @include button-smooth;

    width: 280px;
}

.wb-project-name-input-active {
    background-color: $white;
}

.wb-project-name-changer-anchor {
    position: relative;
    width: 0;
}

.wb-project-name-changer {
    position: absolute;
    left: -36px;
    width: 36px;
    height: 100%;
    cursor: pointer;
    user-select: none;
    display: flex;
    color: $gray3;
    @include wb-c-flex-center;
    @include button-smooth;
}

.wb-project-name-changer:hover {
    color: $green1;
}
.wb-project-name-changer-edit{
  color: $green1;
}


</style>
